import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://nefojnjarmzsmbgxogna.supabase.co";
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5lZm9qbmphcm16c21iZ3hvZ25hIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIxMDIwMDAsImV4cCI6MjA1NzY3ODAwMH0.afbZ5V-T6gBJK1n7zodSOCYMNBYTT4lNeDphUZHqUTU";

export const supabase = createClient(supabaseUrl, supabaseKey);